import moment from "moment";

export const serialDataBits = [5, 6, 7, 8, 9];
export const serialStopBits = [1, 2];
export const serialParity = ["N", "O", "E", "M", "S"];
export const serialBaudRate = [
  50, 75, 110, 134, 150, 200, 300, 600, 1200, 1800, 2400, 4800, 9600, 19200, 38400, 57600, 115200, 230400, 460800,
  500000, 576000, 921600, 1000000, 1152000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000,
];

export const connectionTypes = [
  { id: "modbusRTU", name: "To Modbus RTU Slave" },
  { id: "modbusTCP", name: "To Modbus TCP Slave" },
  { id: "mqttClient", name: "From MQTT Client" },
];

export const monitoringTypes = [
  { id: "general", name: "General" },
  // { id: "scada", name: "Scada" },
];

export const userRoles = [
  { id: "admin", name: "Admin" },
  { id: "operator", name: "Operator" },
];

export const modbusRegisters = [
  { id: "analog_output_holding_registers", name: "Analog Output Holding Registers" },
  { id: "analog_input_registers", name: "Analog Input Registers" },
  { id: "discrete_input_contacts", name: "Discrete Input Contacts" },
  { id: "discrete_output_coils", name: "Discrete Output Coils" },
];

export const credentialMethods = [
  // { id: "callHomeWithBasicScheme", name: "1. Call Home => 2. Connect" },
  // { id: "callHomeWithBearerScheme", name: "Call Home With Bearer Scheme" },
  { id: "connectDirectly", name: "Connect Directly" },
];

export const TIME_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const TIME_FORMAT = "DD/MM/YYYY HH:mm";
export const DATE_FORMAT = "DD/MM/YYYY";
export const SHORT_DATE_FORMAT = "DD/MM HH:mm";
export const SHORT_DATE_TIME_SECOND_FORMAT = "DD/MM HH:mm:ss";

//widgets
export const widgetTypes = [
  { id: "lineChart", name: "Line Chart" },
  { id: "barChart", name: "Bar Chart" },
  { id: "pieChart", name: "Pie Chart" },
  { id: "donutChart", name: "Donut Chart" },
  { id: "radialBarChart", name: "RadialBar Chart" },
  { id: "singleStat", name: "Single Stat" },
  { id: "alertStat", name: "Alarm Stat" },
  { id: "statGrid", name: "Stat Grid" },
  { id: "gaugeChart", name: "Gauge Chart" },
];

//Grid layout
export const rowHeight = 30;

//Bucket
export const maxDataPointOnBucket = 100000;
export const limit = 14;
export const tagsHoursLimit = [
  { tags: 1, hours: 777.8 },
  { tags: 2, hours: 388.9 },
  { tags: 3, hours: 259.3 },
  { tags: 4, hours: 194.4 },
  { tags: 5, hours: 155.6 },
  { tags: 6, hours: 129.6 },
  { tags: 7, hours: 111.1 },
  { tags: 8, hours: 97.2 },
  { tags: 9, hours: 86.4 },
  { tags: 10, hours: 77.8 },
  { tags: 11, hours: 70.7 },
  { tags: 12, hours: 64.8 },
  { tags: 13, hours: 59.8 },
  { tags: 14, hours: 55.6 },
  { tags: 15, hours: 51.9 },
  { tags: 16, hours: 48.6 },
];

export const DATE_PICKER_OPTIONS = {
  opens: "center",
  drops: "down",
  timePicker: true,
  timePicker24Hour: true,
  minYear: 2000,
  maxYear: 2040,
  // maxSpan: {
  //   months: 1,
  // },
  maxDate: moment().endOf("day"),
  locale: {
    format: TIME_FORMAT,
    separator: " - ",
    applyLabel: "Apply",
    cancelLabel: "Cancel",
    fromLabel: "From",
    toLabel: "To",
    customRangeLabel: "Custom Range",
    daysOfWeek: ["M", "T", "W", "T", "F", "S", "S"],
    monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    firstDay: 0,
  },
};

export const dataTypes = [
  {
    type: "Bool",
    title: "Boolean",
    id: "bool",
  },
  {
    type: "Float",
    title: "Float 32 Bit (ABCD)",
    id: "float32_abcd",
  },
  {
    type: "Float",
    title: "Float 32 Bit (BADC)",
    id: "float32_badc",
  },
  {
    type: "Float",
    title: "Float 32 Bit (CDAB)",
    id: "float32_cdab",
  },
  {
    type: "Float",
    title: "Float 32 Bit (DCBA)",
    id: "float32_dcba",
  },
  {
    type: "Float",
    title: "Float 64 Bit (ABCDEFGH)",
    id: "float64_abcdefgh",
  },
  {
    type: "Float",
    title: "Float 64 Bit (BADCFEHG)",
    id: "float64_badcfehg",
  },
  {
    type: "Float",
    title: "Float 64 Bit (GHEFCDAB)",
    id: "float64_ghefcdab",
  },
  {
    type: "Float",
    title: "Float 64 Bit (HGFEDCBA)",
    id: "float64_hgfedcba",
  },
  {
    type: "Int",
    title: "Integer 16 Bit",
    id: "int16",
  },
  {
    type: "Int",
    title: "Integer 32 Bit (ABCD)",
    id: "int32_abcd",
  },
  {
    type: "Int",
    title: "Integer 32 Bit (BACD)",
    id: "int32_bacd",
  },
  {
    type: "Int",
    title: "Integer 32 Bit (CDAB)",
    id: "int32_cdab",
  },
  {
    type: "Int",
    title: "Integer 32 Bit (DCBA)",
    id: "int32_dcba",
  },
  {
    type: "Int",
    title: "Integer 64 Bit (ABCDEFGH)",
    id: "int64_abcdefgh",
  },
  {
    type: "Int",
    title: "Integer 64 Bit (BADCFEHG)",
    id: "int64_badcfehg",
  },
  {
    type: "Int",
    title: "Integer 64 Bit (GHEFCDAB)",
    id: "int64_ghefcdab",
  },
  {
    type: "Int",
    title: "Integer 64 Bit (HGFEDCBA)",
    id: "int64_hgfedcba",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 16 Bit",
    id: "uint16",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 32 Bit (ABCD)",
    id: "uint32_abcd",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 32 Bit (BACD)",
    id: "uint32_bacd",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 32 Bit (CDAB)",
    id: "uint32_cdab",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 32 Bit (DCBA)",
    id: "uint32_dcba",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 64 Bit (ABCDEFGH)",
    id: "uint64_abcdefgh",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 64 Bit (BADCFEHG)",
    id: "uint64_badcfehg",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 64 Bit (GHEFCDAB)",
    id: "uint64_ghefcdab",
  },
  {
    type: "Unsigned Integer",
    title: "Unsigned Integer 64 Bit (HGFEDCBA)",
    id: "uint64_hgfedcba",
  },
];
